import React from 'react'
import type { PresentationSectionProps } from '../../'

import QuoteComponent from '../../../Quote/Quote'
import { PackageGateOrEstimate } from '../../../Quote/views/QuoteView/TieredPackages/TieredPackageGateContext'

export default function Quote(props: PresentationSectionProps) {
  const { WrapperComponent } = props

  return (
    <WrapperComponent {...props}>
      <PackageGateOrEstimate>
        <QuoteComponent inPresentation={true} />
      </PackageGateOrEstimate>
    </WrapperComponent>
  )
}
